<template>
  <div style="height: 100%">
    <div style="display: flex; width: 100%">
      <div style="width: 100%">
        <el-row class="filter-bar" ref="filterBar">
          <el-input v-model="formDatas.bizOrderno" style="width: 150px;" size="mini" placeholder="订单号"
            clearable></el-input>
          <el-input v-model="formDatas.couponSn" style="width: 150px;" size="mini" placeholder="券码"
            clearable></el-input>
          <el-select size="mini" v-model="formDatas.abbnStatus" clearable placeholder="状态"
            style="width: 130px;" @change="partserch">
            <el-option label="待处理" :value="1" key="1"></el-option>
            <el-option label="已处理" :value="2" key="2"></el-option>
            <el-option label="处理失败" :value="3" key="3"></el-option>
          </el-select>
          <div class="filter-actions">
          <el-button type="info" size="mini" icon="el-icon-search" @click="partserch"
            style="">搜索</el-button>
          </div>
        </el-row>
      </div>
    </div>
    <div class="tablemain">
      <div class="tablecss" v-loading="tableLoading" element-loading-background="rgba(255, 255, 255, 0.9)"
        element-loading-text="数据加载中..." element-loading-spinner="el-icon-loading" custom-class="table-loading">
        <div style="width: 100%">
          <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData" :max-height="tableHight"
            :border-x="true" :border-y="true" :scrollWidth="10" :cell-style-option="cellStyleOption"
            style="width: 100%" />
          <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
        </div>
        <div class="table-pagination">
          <ve-pagination :total="totalCount" :page-index="formDatas.currentPage" :page-size="formDatas.pageSize"
            :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]" @on-page-number-change="pageNumberChange"
            @on-page-size-change="pageSizeChange" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { calcTableHeight } from "../../utils/tableHeight.js";
import { getBillBeiguoNotifyList } from "../../api/api";
export default {
  name: "",
  components: {},
  data() {
    return {
      tableLoading: false,
      totalCount: 100,
      tableHight: 520,
      tableData: [],
      formDatas: {
        bizOrderno: '',
        couponSn: '',
        abbnStatus: '',
        currentPage: 1,
        pageSize: 10
      },
      columns: [
        {
          field: "",
          key: "a",
          title: "序号",
          width: 50,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return ++rowIndex;
          },
        },
        {
          field: "bizOrderno",
          key: "bizOrderno",
          title: "分销商订单号",
          width: 250,
          align: "center",
        },
        {
          field: "couponSn",
          key: "couponSn",
          title: "券码",
          align: "center",
          width: 200,
        },
         {
          field: "couponSnOld",
          key: "couponSnOld",
          title: "旧券码",
          align: "center",
          width: 200,
        },
        {
          field: "action",
          key: "action",
          title: "通知类型",
          align: "center",
          width: 100,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            const actionMap = { 'HX': { text: '核销', type: 'primary' }, 'HY': { text: '还原为未用', type: 'info' }, 'YQ': { text: '延期', type: 'warning' } };
            const action = actionMap[row.action];
            if (action) {
              return h('el-tag', { props: { type: action.type, size: 'mini' } }, action.text);
            }
            return row.action || '-';
          },
        },
        {
          field: "usedShopName",
          key: "usedShopName",
          title: "使用门店",
          align: "center",
          width: 120,
        },
        {
          field: "isOcm",
          key: "isOcm",
          title: "是否OCM券",
          align: "center",
          width: 90,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            const isOcmMap = { 0: { text: '否', type: 'info' }, 1: { text: '是', type: 'primary' } };
            const isOcm = isOcmMap[row.isOcm];
            if (isOcm) {
              return h('el-tag', { props: { type: isOcm.type, size: 'mini' } }, isOcm.text);
            }
            return '-';
          },
        },
        {
          field: "usedStatus",
          key: "usedStatus",
          title: "使用状态",
          align: "center",
          width: 80,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            const usedStatusMap = { 0: { text: '未用', type: 'info' }, 1: { text: '已用', type: 'success' } };
            const usedStatus = usedStatusMap[row.usedStatus];
            if (usedStatus) {
              return h('el-tag', { props: { type: usedStatus.type, size: 'mini' } }, usedStatus.text);
            }
            return '-';
          },
        },
        {
          field: "abbnStatus",
          key: "abbnStatus",
          title: "处理状态",
          align: "center",
          width: 90,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            const statusMap = {
              1: { text: '待处理', type: 'warning' },
              2: { text: '已处理', type: 'success' },
              3: { text: '处理失败', type: 'danger' }
            };
            const status = statusMap[row.abbnStatus];
            if (status) {
              return h('el-tag', { props: { type: status.type, size: 'mini' } }, status.text);
            }
            return '-';
          },
        },
        {
          field: "abbnStatusDes",
          key: "abbnStatusDes",
          title: "状态描述",
          align: "center",
          width: 150,
        },
        {
          field: "createtime",
          key: "createtime",
          title: "创建时间",
          align: "center",
          width: 170,
        },
      ],
      cellStyleOption: {
        headerCellClass: ({ column, rowIndex }) => {
          if (rowIndex === 0) {
            return "table-header-cell-class";
          }
        },
      },
    };
  },
  mounted() {
    this.getList();
  },
  activated() {
    this.watchFlag = true;
    this.$nextTick(() => {
      this.windheight = this.$store.state.windheight;
      this.tableHight = calcTableHeight(this, this.windheight, 140);
    });
  },
  watch: {
    "$store.state.windheight"(val) {
      this.$nextTick(() => {
        if (this.watchFlag) {
          this.tableHight = calcTableHeight(this, val, 140);
        }
      });
    },
  },
  methods: {
    getList() {
      this.tableLoading = true;
      getBillBeiguoNotifyList(this.formDatas).then((res) => {
        this.tableLoading = false;
        this.tableData = res.data || [];
        this.totalCount = res.total || 0;
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    partserch() {
      this.formDatas.currentPage = 1;
      this.getList();
    },
    pageNumberChange(pageIndex) {
      this.formDatas.currentPage = pageIndex;
      this.getList();
    },
    pageSizeChange(pageSize) {
      this.formDatas.pageSize = pageSize;
      this.getList();
    },
  },
};
</script>

<style scoped></style>
